import axios from 'axios';

//****************************DOCUMENTS ENDPOINTS(GET):*********************************************\\

export const getHomeDirectory = async (cust_id) => {
	if (cust_id) {
		try {
			const { data } = await axios({
				method: 'GET',
				url: `/api2.0/canshare/GetHomeDirectory?custId=${JSON.stringify(
					cust_id,
				)}`,
				headers: { 'Content-Type': 'application/json;charset=UTF-8' },
				data: null,
			});
			return data;
		} catch (error) {
			console.log('ERROR :>> ', error);
			return { Success: false, Message: error, home_dir_id: 0 };
		}
	}
};

export const getDocumentList = async (custId = 100, dirId = 0) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/GetDocumentList?custId=${custId}&dirId=${dirId}`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return [];
	}
};

export const getDocumentPreviewUrl = async (fileId = '0') => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/GetDocumentPreviewUrl?fileId=${fileId}`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return '/';
	}
};

//*************** Manage Endpoints ****************/

export const createNewFolder = async (parentDirId, custId, dirName = '') => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/AddNewFolder?parentDirId=${parentDirId}&custId=${custId}`,
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { Success: false, Message: error };
	}
};

export const renameFile = async (fileId, name) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/RenameFile?fileId=${fileId}&name=${name}`,
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { Success: false, Message: error };
	}
};

export const renameDir = async (dirId, name) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/RenameDirectory?dirId=${dirId}&name=${name}`,
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { Success: false, Message: error };
	}
};

export const deleteFile = async (fileId) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/DeleteFile?fileId=${fileId}`,
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { Success: false, Message: error };
	}
};

export const deleteDirectory = async (dirId) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/DeleteDirectory?dirId=${dirId}`,
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { Success: false, Message: error };
	}
};

export const moveFileToDirectory = async (fileId, dirId, name) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/MoveFileToDirectory?fileId=${fileId}&dirId=${dirId}&fileName=${name}`,
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { Success: false, Message: error };
	}
};

export const moveDirectory = async (source_dir_id, dest_dir_id, name) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/MoveDirectory?sourceDirId=${source_dir_id}&destDirId=${dest_dir_id}&dirName=${name}`,
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { Success: false, Message: error };
	}
};

export const getDirectoryPermissions = async (dirId, custId) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/canshare/GetPermissionsOnDirectory?dirId=${dirId}&custId=${custId}`,
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { Success: false, Message: error };
	}
};

export const setDirectoryPermissions = async (payload) => {
	try {
		const { data } = await axios({
			method: 'POST',
			url: `/api2.0/canshare/SetPermissionsOnDirectory`,
			data: payload,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { Success: false, Message: error };
	}
};

// endpoint call not used currently as it is handled by uppy uploader
export const uploadSingleFile = async (custId, dirId, file) => {
	const formData = new FormData();

	formData.append('File', file);
	formData.append('CustId', custId);
	formData.append('DirId', dirId);

	const options = {
		method: 'POST',
		body: formData,
	};

	const res = await fetch('/api2.0/canshare/Upload', options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		/**@type {FileData} data */
		const data = await res.json();
		return data;
	}
};

/**
 * Get count of items that will be deleted recursively (admin-only)
 * @param {string} fileIds - Comma-separated list of file IDs (e.g., "123,456,789")
 * @param {string} dirIds - Comma-separated list of directory IDs (e.g., "305,306")
 * @param {string} username - Username for admin validation (e.g., "admin@company.com")
 * @returns {Promise<Object>} Response with TotalFiles and TotalFolders count
 */
export const getDeleteCount = async (fileIds = '', dirIds = '', username = '') => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/CANShare/GetDeleteCount?fileIds=${fileIds}&dirIds=${dirIds}&username=${username}`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
			data: null,
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { 
			Success: false, 
			Message: error.response?.data?.Message || error.message || 'Failed to get delete count' 
		};
	}
};

/**
 * Delete selected files and directories recursively (admin-only)
 * @param {string} fileIds - Comma-separated list of file IDs (e.g., "123,456,789")
 * @param {string} dirIds - Comma-separated list of directory IDs (e.g., "305,306")
 * @param {string} username - Username for admin validation (e.g., "admin@company.com")
 * @returns {Promise<Object>} Response with deletion results
 */
export const deleteSelectedItems = async (fileIds = '', dirIds = '', username = '') => {
	try {
		const { data } = await axios({
			method: 'POST',
			url: `/api2.0/CANShare/DeleteSelectedItems`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
			data: {
				Username: username,
				FileIds: fileIds,
				DirectoryIds: dirIds
			},
		});
		return data;
	} catch (error) {
		console.log('ERROR :>> ', error);
		return { 
			Success: false, 
			Message: error.response?.data?.Message || error.message || 'Failed to delete items' 
		};
	}
};
